<template>
  <v-autocomplete
    id="temas-select"
    v-model="filter.instituicao"
    :items="values"
    label="Instituição"
    placeholder="Selecione..."
    v-on:change="$emit('onChange')"
    :disabled="disabled"
    :clearable="true"
    :return-object="true"
    :rules="rules"
  >
    <template slot="no-data"> Nenhuma Instituicao retornada </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "AppEixoCombobox",
  props: {
    rules: {
      type: Array,
      default: () => {
        [];
      },
    },
    defaultValue: {
      type: String | Number,
    },
    filter: {
      type: Object,
      default: () => {
        ({ instituicao: {} });
      },
    },

    disabled: { type: Boolean, default: false },
  },
  watch: {
    defaultValue(value) {
      this.values = value;
    },
  },

  data() {
    return {
      values: ["MUNICIPIO", "SEBRAE", "OUTRA"],
    };
  },
};
</script>
